import React from 'react';
import {Datagrid, List, TextField} from 'react-admin';
import {DateTimeField, DownloadFileContentButton} from "../../components";


export const EduSyncStudentEnrollmentHistoriesList = props => (
    <List filters={false} {...props} exporter={false} bulkActions={false}>
        <Datagrid rowClick={false}>
            <TextField source="id"/>
            <TextField source="createdBy"/>
            <DateTimeField source="createdOn" format="DD/MM HH:mm"/>
            <DownloadFileContentButton extension={'.xlsx'}/>
        </Datagrid>
    </List>
);

export default EduSyncStudentEnrollmentHistoriesList
